//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { formatISO } from "date-fns";
export class ApiExtension {

    protected transformOptions = async (
        options: RequestInit
    ): Promise<RequestInit> => {
        options.credentials = "include";
        options.headers = {
            ...options.headers,
        };
        return Promise.resolve(options);
    };
}

export interface IAdminClient {

    /**
     * @return Success
     */
    adminGetEvents(): Promise<EventInformation[]>;

    /**
     * @return Success
     */
    adminGetPreviousEvents(): Promise<EventInformation[]>;

    /**
     * @return Success
     */
    adminGetEvent(eventId: string): Promise<EventDto>;
}

export class AdminClient extends ApiExtension implements IAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    adminGetEvents(): Promise<EventInformation[]> {
        let url_ = this.baseUrl + "/api/Admin/events";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminGetEvents(_response);
        });
    }

    protected processAdminGetEvents(response: Response): Promise<EventInformation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventInformation[]>(null as any);
    }

    /**
     * @return Success
     */
    adminGetPreviousEvents(): Promise<EventInformation[]> {
        let url_ = this.baseUrl + "/api/Admin/events/previous";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminGetPreviousEvents(_response);
        });
    }

    protected processAdminGetPreviousEvents(response: Response): Promise<EventInformation[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventInformation[]>(null as any);
    }

    /**
     * @return Success
     */
    adminGetEvent(eventId: string): Promise<EventDto> {
        let url_ = this.baseUrl + "/api/Admin/events/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdminGetEvent(_response);
        });
    }

    protected processAdminGetEvent(response: Response): Promise<EventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDto>(null as any);
    }
}

export interface IAttendanceClient {

    /**
     * @return Success
     */
    getLoggedInUserAttendanceForEvent(eventId: string): Promise<AttendanceDto>;

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateUserAttendance(body: AttendanceDto | undefined): Promise<void>;

    /**
     * @return Success
     */
    getAttendancesForEvent(eventId: string): Promise<AttendanceDto[]>;
}

export class AttendanceClient extends ApiExtension implements IAttendanceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLoggedInUserAttendanceForEvent(eventId: string): Promise<AttendanceDto> {
        let url_ = this.baseUrl + "/api/Attendance/User/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLoggedInUserAttendanceForEvent(_response);
        });
    }

    protected processGetLoggedInUserAttendanceForEvent(response: Response): Promise<AttendanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttendanceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    updateUserAttendance(body: AttendanceDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Attendance/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserAttendance(_response);
        });
    }

    protected processUpdateUserAttendance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAttendancesForEvent(eventId: string): Promise<AttendanceDto[]> {
        let url_ = this.baseUrl + "/api/Attendance/EventAttendances/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendancesForEvent(_response);
        });
    }

    protected processGetAttendancesForEvent(response: Response): Promise<AttendanceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttendanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttendanceDto[]>(null as any);
    }
}

export interface IAttendanceReportClient {

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceInfoByDepartmentAsString(eventId: string | undefined): Promise<void>;

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return No Content
     */
    getAttendanceReportAsCsv(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<void>;

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceReportAsCsvWithSensitiveData(eventId: string | undefined): Promise<void>;

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return Success
     */
    getAttendeeNamesAsString(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<string[]>;

    /**
     * @param eventId (optional) 
     * @return Success
     */
    getDietaryConsiderationsAsStringListForEvent(eventId: string | undefined): Promise<string[]>;

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return No Content
     */
    getAttendanceReportAsPdf(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<void>;

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceReportAsPdfWithSensitiveData(eventId: string | undefined): Promise<void>;
}

export class AttendanceReportClient extends ApiExtension implements IAttendanceReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceInfoByDepartmentAsString(eventId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AttendanceReport?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendanceInfoByDepartmentAsString(_response);
        });
    }

    protected processGetAttendanceInfoByDepartmentAsString(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return No Content
     */
    getAttendanceReportAsCsv(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AttendanceReport/AsCsv?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (onlyAttending === null)
            throw new Error("The parameter 'onlyAttending' cannot be null.");
        else if (onlyAttending !== undefined)
            url_ += "onlyAttending=" + encodeURIComponent("" + onlyAttending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendanceReportAsCsv(_response);
        });
    }

    protected processGetAttendanceReportAsCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceReportAsCsvWithSensitiveData(eventId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AttendanceReport/AsCsvWithSensitiveData?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendanceReportAsCsvWithSensitiveData(_response);
        });
    }

    protected processGetAttendanceReportAsCsvWithSensitiveData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return Success
     */
    getAttendeeNamesAsString(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AttendanceReport/AttendeeNamesAsString?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (onlyAttending === null)
            throw new Error("The parameter 'onlyAttending' cannot be null.");
        else if (onlyAttending !== undefined)
            url_ += "onlyAttending=" + encodeURIComponent("" + onlyAttending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendeeNamesAsString(_response);
        });
    }

    protected processGetAttendeeNamesAsString(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return Success
     */
    getDietaryConsiderationsAsStringListForEvent(eventId: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/AttendanceReport/DietaryConsiderationsAsString?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDietaryConsiderationsAsStringListForEvent(_response);
        });
    }

    protected processGetDietaryConsiderationsAsStringListForEvent(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @param onlyAttending (optional) 
     * @return No Content
     */
    getAttendanceReportAsPdf(eventId: string | undefined, onlyAttending: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AttendanceReport/AsPdf?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        if (onlyAttending === null)
            throw new Error("The parameter 'onlyAttending' cannot be null.");
        else if (onlyAttending !== undefined)
            url_ += "onlyAttending=" + encodeURIComponent("" + onlyAttending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendanceReportAsPdf(_response);
        });
    }

    protected processGetAttendanceReportAsPdf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return No Content
     */
    getAttendanceReportAsPdfWithSensitiveData(eventId: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AttendanceReport/AsPdfWithSensitiveData?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAttendanceReportAsPdfWithSensitiveData(_response);
        });
    }

    protected processGetAttendanceReportAsPdfWithSensitiveData(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAuthClient {

    /**
     * @param postLoginRedirectUri (optional) 
     * @return Success
     */
    login(postLoginRedirectUri: string | undefined): Promise<void>;

    /**
     * @param postLogoutRedirectUri (optional) 
     * @return Success
     */
    logout(postLogoutRedirectUri: string | undefined): Promise<void>;

    /**
     * @return Success
     */
    account(): Promise<void>;
}

export class AuthClient extends ApiExtension implements IAuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param postLoginRedirectUri (optional) 
     * @return Success
     */
    login(postLoginRedirectUri: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/login?";
        if (postLoginRedirectUri === null)
            throw new Error("The parameter 'postLoginRedirectUri' cannot be null.");
        else if (postLoginRedirectUri !== undefined)
            url_ += "postLoginRedirectUri=" + encodeURIComponent("" + postLoginRedirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param postLogoutRedirectUri (optional) 
     * @return Success
     */
    logout(postLogoutRedirectUri: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/logout?";
        if (postLogoutRedirectUri === null)
            throw new Error("The parameter 'postLogoutRedirectUri' cannot be null.");
        else if (postLogoutRedirectUri !== undefined)
            url_ += "postLogoutRedirectUri=" + encodeURIComponent("" + postLogoutRedirectUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    account(): Promise<void> {
        let url_ = this.baseUrl + "/api/Auth/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAccount(_response);
        });
    }

    protected processAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IDevelopmentClient {

    /**
     * @return Success
     */
    throwException(): Promise<void>;

    /**
     * @param withImages (optional) 
     * @return Success
     */
    triggerUpdateUsersAndOrganizationalStructureFromGraph(withImages: boolean | undefined): Promise<Department>;

    /**
     * @return Success
     */
    triggerUpdateAttendancesForNewAndModifiedUsers(): Promise<void>;
}

export class DevelopmentClient extends ApiExtension implements IDevelopmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    throwException(): Promise<void> {
        let url_ = this.baseUrl + "/api/Development/ThrowException";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processThrowException(_response);
        });
    }

    protected processThrowException(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param withImages (optional) 
     * @return Success
     */
    triggerUpdateUsersAndOrganizationalStructureFromGraph(withImages: boolean | undefined): Promise<Department> {
        let url_ = this.baseUrl + "/api/Development/TriggerUpdateUsersAndOrganizationalStructureFromGraph?";
        if (withImages === null)
            throw new Error("The parameter 'withImages' cannot be null.");
        else if (withImages !== undefined)
            url_ += "withImages=" + encodeURIComponent("" + withImages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerUpdateUsersAndOrganizationalStructureFromGraph(_response);
        });
    }

    protected processTriggerUpdateUsersAndOrganizationalStructureFromGraph(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Department.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * @return Success
     */
    triggerUpdateAttendancesForNewAndModifiedUsers(): Promise<void> {
        let url_ = this.baseUrl + "/api/Development/TriggerUpdateAttendancesForNewAndModifiedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerUpdateAttendancesForNewAndModifiedUsers(_response);
        });
    }

    protected processTriggerUpdateAttendancesForNewAndModifiedUsers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEventClient {

    /**
     * @return Success
     */
    event(eventId: string): Promise<EventDto>;

    /**
     * @return Success
     */
    getCreateEventDto(): Promise<EditEventDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: EventDto | undefined): Promise<string>;

    /**
     * @param eventId (optional) 
     * @return Success
     */
    getEventCopyDto(eventId: string | undefined): Promise<EditEventDto>;

    /**
     * @return Success
     */
    getEditEventDto(eventId: string): Promise<EditEventDto>;

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EventDto | undefined): Promise<string>;

    /**
     * @return Success
     */
    delete(eventId: string): Promise<void>;
}

export class EventClient extends ApiExtension implements IEventClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    event(eventId: string): Promise<EventDto> {
        let url_ = this.baseUrl + "/api/Event/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEvent(_response);
        });
    }

    protected processEvent(response: Response): Promise<EventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventDto>(null as any);
    }

    /**
     * @return Success
     */
    getCreateEventDto(): Promise<EditEventDto> {
        let url_ = this.baseUrl + "/api/Event/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreateEventDto(_response);
        });
    }

    protected processGetCreateEventDto(response: Response): Promise<EditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditEventDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: EventDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Event/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param eventId (optional) 
     * @return Success
     */
    getEventCopyDto(eventId: string | undefined): Promise<EditEventDto> {
        let url_ = this.baseUrl + "/api/Event/copy?";
        if (eventId === null)
            throw new Error("The parameter 'eventId' cannot be null.");
        else if (eventId !== undefined)
            url_ += "eventId=" + encodeURIComponent("" + eventId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEventCopyDto(_response);
        });
    }

    protected processGetEventCopyDto(response: Response): Promise<EditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditEventDto>(null as any);
    }

    /**
     * @return Success
     */
    getEditEventDto(eventId: string): Promise<EditEventDto> {
        let url_ = this.baseUrl + "/api/Event/edit/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEditEventDto(_response);
        });
    }

    protected processGetEditEventDto(response: Response): Promise<EditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditEventDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EventDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Event/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    delete(eventId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Event/delete/{eventId}";
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEventOverviewClient {

    /**
     * @param owned (optional) 
     * @return Success
     */
    eventOverview(owned: boolean | undefined): Promise<EventWithUserAttendance[]>;

    /**
     * @param owned (optional) 
     * @return Success
     */
    previous(owned: boolean | undefined): Promise<PreviousEvent[]>;
}

export class EventOverviewClient extends ApiExtension implements IEventOverviewClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param owned (optional) 
     * @return Success
     */
    eventOverview(owned: boolean | undefined): Promise<EventWithUserAttendance[]> {
        let url_ = this.baseUrl + "/api/EventOverview?";
        if (owned === null)
            throw new Error("The parameter 'owned' cannot be null.");
        else if (owned !== undefined)
            url_ += "owned=" + encodeURIComponent("" + owned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEventOverview(_response);
        });
    }

    protected processEventOverview(response: Response): Promise<EventWithUserAttendance[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventWithUserAttendance.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventWithUserAttendance[]>(null as any);
    }

    /**
     * @param owned (optional) 
     * @return Success
     */
    previous(owned: boolean | undefined): Promise<PreviousEvent[]> {
        let url_ = this.baseUrl + "/api/EventOverview/previous?";
        if (owned === null)
            throw new Error("The parameter 'owned' cannot be null.");
        else if (owned !== undefined)
            url_ += "owned=" + encodeURIComponent("" + owned) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrevious(_response);
        });
    }

    protected processPrevious(response: Response): Promise<PreviousEvent[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreviousEvent.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreviousEvent[]>(null as any);
    }
}

export interface IHealthCheckClient {

    /**
     * @return Success
     */
    healthCheck(): Promise<void>;
}

export class HealthCheckClient extends ApiExtension implements IHealthCheckClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    healthCheck(): Promise<void> {
        let url_ = this.baseUrl + "/api/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthCheck(_response);
        });
    }

    protected processHealthCheck(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IOrganizationClient {

    /**
     * @return Success
     */
    getOrganizationalStructure(): Promise<Department>;

    /**
     * @return Success
     */
    getAllSimpleUsers(): Promise<SimpleUser[]>;

    /**
     * @return Success
     */
    getEntraIdGroups(): Promise<EntraIdGroup[]>;
}

export class OrganizationClient extends ApiExtension implements IOrganizationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationalStructure(): Promise<Department> {
        let url_ = this.baseUrl + "/api/Organization/GetOrganizationalStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationalStructure(_response);
        });
    }

    protected processGetOrganizationalStructure(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Department.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * @return Success
     */
    getAllSimpleUsers(): Promise<SimpleUser[]> {
        let url_ = this.baseUrl + "/api/Organization/GetAllSimpleUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllSimpleUsers(_response);
        });
    }

    protected processGetAllSimpleUsers(response: Response): Promise<SimpleUser[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SimpleUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleUser[]>(null as any);
    }

    /**
     * @return Success
     */
    getEntraIdGroups(): Promise<EntraIdGroup[]> {
        let url_ = this.baseUrl + "/api/Organization/GetEntraIdGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEntraIdGroups(_response);
        });
    }

    protected processGetEntraIdGroups(response: Response): Promise<EntraIdGroup[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntraIdGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntraIdGroup[]>(null as any);
    }
}

export interface ISendEmailClient {

    /**
     * @param body (optional) 
     * @return Success
     */
    send(body: SendEmailWithEvent | undefined): Promise<void>;
}

export class SendEmailClient extends ApiExtension implements ISendEmailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    send(body: SendEmailWithEvent | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserClient {

    /**
     * @return Success
     */
    getUserWithPreferences(): Promise<User>;

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPreferences(body: UserPreferences | undefined): Promise<User>;
}

export class UserClient extends ApiExtension implements IUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserWithPreferences(): Promise<User> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserWithPreferences(_response);
        });
    }

    protected processGetUserWithPreferences(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUserPreferences(body: UserPreferences | undefined): Promise<User> {
        let url_ = this.baseUrl + "/api/User/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserPreferences(_response);
        });
    }

    protected processUpdateUserPreferences(response: Response): Promise<User> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = User.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<User>(null as any);
    }
}

export class AttendanceDto implements IAttendanceDto {
    eventId?: string;
    userId?: string;
    name?: string | undefined;
    image?: string | undefined;
    departmentName?: string | undefined;
    comment?: string | undefined;
    shareDietaryConsiderations?: boolean;
    guestCount?: number | undefined;
    attendanceStatus?: AttendanceStatus;
    attendanceStatusUpdatedAt?: Date | undefined;
    waitListSpot?: number | undefined;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.departmentName = _data["departmentName"];
            this.comment = _data["comment"];
            this.shareDietaryConsiderations = _data["shareDietaryConsiderations"];
            this.guestCount = _data["guestCount"];
            this.attendanceStatus = _data["attendanceStatus"];
            this.attendanceStatusUpdatedAt = _data["attendanceStatusUpdatedAt"] ? new Date(_data["attendanceStatusUpdatedAt"].toString()) : <any>undefined;
            this.waitListSpot = _data["waitListSpot"];
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["image"] = this.image;
        data["departmentName"] = this.departmentName;
        data["comment"] = this.comment;
        data["shareDietaryConsiderations"] = this.shareDietaryConsiderations;
        data["guestCount"] = this.guestCount;
        data["attendanceStatus"] = this.attendanceStatus;
        data["attendanceStatusUpdatedAt"] = this.attendanceStatusUpdatedAt ? this.attendanceStatusUpdatedAt.toISOString() : <any>undefined;
        data["waitListSpot"] = this.waitListSpot;
        return data;
    }
}

export interface IAttendanceDto {
    eventId?: string;
    userId?: string;
    name?: string | undefined;
    image?: string | undefined;
    departmentName?: string | undefined;
    comment?: string | undefined;
    shareDietaryConsiderations?: boolean;
    guestCount?: number | undefined;
    attendanceStatus?: AttendanceStatus;
    attendanceStatusUpdatedAt?: Date | undefined;
    waitListSpot?: number | undefined;
}

export enum AttendanceStatus {
    Attending = "Attending",
    Waiting = "Waiting",
    NotAttending = "NotAttending",
    Invited = "Invited",
}

export class Department implements IDepartment {
    id?: string | undefined;
    name?: string | undefined;
    invited?: boolean;
    subDepartments?: Department[] | undefined;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.subDepartments) {
                this.subDepartments = [];
                for (let i = 0; i < data.subDepartments.length; i++) {
                    let item = data.subDepartments[i];
                    this.subDepartments[i] = item && !(<any>item).toJSON ? new Department(item) : <Department>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.invited = _data["invited"];
            if (Array.isArray(_data["subDepartments"])) {
                this.subDepartments = [] as any;
                for (let item of _data["subDepartments"])
                    this.subDepartments!.push(Department.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["invited"] = this.invited;
        if (Array.isArray(this.subDepartments)) {
            data["subDepartments"] = [];
            for (let item of this.subDepartments)
                data["subDepartments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDepartment {
    id?: string | undefined;
    name?: string | undefined;
    invited?: boolean;
    subDepartments?: IDepartment[] | undefined;
}

export class EditEventDto implements IEditEventDto {
    eventDto?: EventDto;
    allUsers?: SimpleUser[] | undefined;
    entraIdGroups?: EntraIdGroup[] | undefined;
    departmentStructure?: Department;
    eventType?: EventType;

    constructor(data?: IEditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.eventDto = data.eventDto && !(<any>data.eventDto).toJSON ? new EventDto(data.eventDto) : <EventDto>this.eventDto;
            if (data.allUsers) {
                this.allUsers = [];
                for (let i = 0; i < data.allUsers.length; i++) {
                    let item = data.allUsers[i];
                    this.allUsers[i] = item && !(<any>item).toJSON ? new SimpleUser(item) : <SimpleUser>item;
                }
            }
            if (data.entraIdGroups) {
                this.entraIdGroups = [];
                for (let i = 0; i < data.entraIdGroups.length; i++) {
                    let item = data.entraIdGroups[i];
                    this.entraIdGroups[i] = item && !(<any>item).toJSON ? new EntraIdGroup(item) : <EntraIdGroup>item;
                }
            }
            this.departmentStructure = data.departmentStructure && !(<any>data.departmentStructure).toJSON ? new Department(data.departmentStructure) : <Department>this.departmentStructure;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDto = _data["eventDto"] ? EventDto.fromJS(_data["eventDto"]) : <any>undefined;
            if (Array.isArray(_data["allUsers"])) {
                this.allUsers = [] as any;
                for (let item of _data["allUsers"])
                    this.allUsers!.push(SimpleUser.fromJS(item));
            }
            if (Array.isArray(_data["entraIdGroups"])) {
                this.entraIdGroups = [] as any;
                for (let item of _data["entraIdGroups"])
                    this.entraIdGroups!.push(EntraIdGroup.fromJS(item));
            }
            this.departmentStructure = _data["departmentStructure"] ? Department.fromJS(_data["departmentStructure"]) : <any>undefined;
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): EditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDto"] = this.eventDto ? this.eventDto.toJSON() : <any>undefined;
        if (Array.isArray(this.allUsers)) {
            data["allUsers"] = [];
            for (let item of this.allUsers)
                data["allUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.entraIdGroups)) {
            data["entraIdGroups"] = [];
            for (let item of this.entraIdGroups)
                data["entraIdGroups"].push(item.toJSON());
        }
        data["departmentStructure"] = this.departmentStructure ? this.departmentStructure.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IEditEventDto {
    eventDto?: IEventDto;
    allUsers?: ISimpleUser[] | undefined;
    entraIdGroups?: IEntraIdGroup[] | undefined;
    departmentStructure?: IDepartment;
    eventType?: EventType;
}

export class EntraIdGroup implements IEntraIdGroup {
    name?: string | undefined;
    objectId?: string | undefined;

    constructor(data?: IEntraIdGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.objectId = _data["objectId"];
        }
    }

    static fromJS(data: any): EntraIdGroup {
        data = typeof data === 'object' ? data : {};
        let result = new EntraIdGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["objectId"] = this.objectId;
        return data;
    }
}

export interface IEntraIdGroup {
    name?: string | undefined;
    objectId?: string | undefined;
}

export class EventDto implements IEventDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    registrationDeadline?: Date;
    openingTimeForRegistration?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    minAttendees?: number | undefined;
    readonly allowGuests?: boolean;
    maxGuestsPerAttendee?: number;
    eventType?: EventType;
    numberOfParticipants?: number;
    readonly isFull?: boolean;
    readonly isOpeningTime?: boolean;
    numberOfWaitingParticipants?: number;
    owner?: SimpleUser;
    collaborators?: SimpleUser[] | undefined;
    invitedDepartmentIds?: string[] | undefined;
    invitedEntraGroupIds?: string[] | undefined;
    personallyInvitedUsers?: SimpleUser[] | undefined;

    constructor(data?: IEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.owner = data.owner && !(<any>data.owner).toJSON ? new SimpleUser(data.owner) : <SimpleUser>this.owner;
            if (data.collaborators) {
                this.collaborators = [];
                for (let i = 0; i < data.collaborators.length; i++) {
                    let item = data.collaborators[i];
                    this.collaborators[i] = item && !(<any>item).toJSON ? new SimpleUser(item) : <SimpleUser>item;
                }
            }
            if (data.personallyInvitedUsers) {
                this.personallyInvitedUsers = [];
                for (let i = 0; i < data.personallyInvitedUsers.length; i++) {
                    let item = data.personallyInvitedUsers[i];
                    this.personallyInvitedUsers[i] = item && !(<any>item).toJSON ? new SimpleUser(item) : <SimpleUser>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.registrationDeadline = _data["registrationDeadline"] ? new Date(_data["registrationDeadline"].toString()) : <any>undefined;
            this.openingTimeForRegistration = _data["openingTimeForRegistration"] ? new Date(_data["openingTimeForRegistration"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.maxAttendees = _data["maxAttendees"];
            this.minAttendees = _data["minAttendees"];
            (<any>this).allowGuests = _data["allowGuests"];
            this.maxGuestsPerAttendee = _data["maxGuestsPerAttendee"];
            this.eventType = _data["eventType"];
            this.numberOfParticipants = _data["numberOfParticipants"];
            (<any>this).isFull = _data["isFull"];
            (<any>this).isOpeningTime = _data["isOpeningTime"];
            this.numberOfWaitingParticipants = _data["numberOfWaitingParticipants"];
            this.owner = _data["owner"] ? SimpleUser.fromJS(_data["owner"]) : <any>undefined;
            if (Array.isArray(_data["collaborators"])) {
                this.collaborators = [] as any;
                for (let item of _data["collaborators"])
                    this.collaborators!.push(SimpleUser.fromJS(item));
            }
            if (Array.isArray(_data["invitedDepartmentIds"])) {
                this.invitedDepartmentIds = [] as any;
                for (let item of _data["invitedDepartmentIds"])
                    this.invitedDepartmentIds!.push(item);
            }
            if (Array.isArray(_data["invitedEntraGroupIds"])) {
                this.invitedEntraGroupIds = [] as any;
                for (let item of _data["invitedEntraGroupIds"])
                    this.invitedEntraGroupIds!.push(item);
            }
            if (Array.isArray(_data["personallyInvitedUsers"])) {
                this.personallyInvitedUsers = [] as any;
                for (let item of _data["personallyInvitedUsers"])
                    this.personallyInvitedUsers!.push(SimpleUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EventDto {
        data = typeof data === 'object' ? data : {};
        let result = new EventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["registrationDeadline"] = this.registrationDeadline ? this.registrationDeadline.toISOString() : <any>undefined;
        data["openingTimeForRegistration"] = this.openingTimeForRegistration ? this.openingTimeForRegistration.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["maxAttendees"] = this.maxAttendees;
        data["minAttendees"] = this.minAttendees;
        data["allowGuests"] = this.allowGuests;
        data["maxGuestsPerAttendee"] = this.maxGuestsPerAttendee;
        data["eventType"] = this.eventType;
        data["numberOfParticipants"] = this.numberOfParticipants;
        data["isFull"] = this.isFull;
        data["isOpeningTime"] = this.isOpeningTime;
        data["numberOfWaitingParticipants"] = this.numberOfWaitingParticipants;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        if (Array.isArray(this.collaborators)) {
            data["collaborators"] = [];
            for (let item of this.collaborators)
                data["collaborators"].push(item.toJSON());
        }
        if (Array.isArray(this.invitedDepartmentIds)) {
            data["invitedDepartmentIds"] = [];
            for (let item of this.invitedDepartmentIds)
                data["invitedDepartmentIds"].push(item);
        }
        if (Array.isArray(this.invitedEntraGroupIds)) {
            data["invitedEntraGroupIds"] = [];
            for (let item of this.invitedEntraGroupIds)
                data["invitedEntraGroupIds"].push(item);
        }
        if (Array.isArray(this.personallyInvitedUsers)) {
            data["personallyInvitedUsers"] = [];
            for (let item of this.personallyInvitedUsers)
                data["personallyInvitedUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEventDto {
    id?: string;
    name?: string | undefined;
    description?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    registrationDeadline?: Date;
    openingTimeForRegistration?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    minAttendees?: number | undefined;
    allowGuests?: boolean;
    maxGuestsPerAttendee?: number;
    eventType?: EventType;
    numberOfParticipants?: number;
    isFull?: boolean;
    isOpeningTime?: boolean;
    numberOfWaitingParticipants?: number;
    owner?: ISimpleUser;
    collaborators?: ISimpleUser[] | undefined;
    invitedDepartmentIds?: string[] | undefined;
    invitedEntraGroupIds?: string[] | undefined;
    personallyInvitedUsers?: ISimpleUser[] | undefined;
}

export class EventInformation implements IEventInformation {
    eventId?: string;
    name?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    numberOfParticipants?: number;
    numberOfWaitingParticipants?: number;
    maxGuestsPerAttendee?: number;

    constructor(data?: IEventInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.maxAttendees = _data["maxAttendees"];
            this.numberOfParticipants = _data["numberOfParticipants"];
            this.numberOfWaitingParticipants = _data["numberOfWaitingParticipants"];
            this.maxGuestsPerAttendee = _data["maxGuestsPerAttendee"];
        }
    }

    static fromJS(data: any): EventInformation {
        data = typeof data === 'object' ? data : {};
        let result = new EventInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["maxAttendees"] = this.maxAttendees;
        data["numberOfParticipants"] = this.numberOfParticipants;
        data["numberOfWaitingParticipants"] = this.numberOfWaitingParticipants;
        data["maxGuestsPerAttendee"] = this.maxGuestsPerAttendee;
        return data;
    }
}

export interface IEventInformation {
    eventId?: string;
    name?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    numberOfParticipants?: number;
    numberOfWaitingParticipants?: number;
    maxGuestsPerAttendee?: number;
}

export enum EventType {
    Professional = "Professional",
    Social = "Social",
    Sports = "Sports",
}

export class EventWithUserAttendance implements IEventWithUserAttendance {
    eventId?: string;
    name?: string | undefined;
    startDateTime?: Date;
    registrationDeadline?: Date;
    openingTimeForRegistration?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    numberOfParticipants?: number;
    readonly isFull?: boolean;
    numberOfWaitingParticipants?: number;
    maxGuestsPerAttendee?: number;
    attendance?: AttendanceDto;
    eventType?: EventType;

    constructor(data?: IEventWithUserAttendance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.attendance = data.attendance && !(<any>data.attendance).toJSON ? new AttendanceDto(data.attendance) : <AttendanceDto>this.attendance;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.name = _data["name"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.registrationDeadline = _data["registrationDeadline"] ? new Date(_data["registrationDeadline"].toString()) : <any>undefined;
            this.openingTimeForRegistration = _data["openingTimeForRegistration"] ? new Date(_data["openingTimeForRegistration"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.maxAttendees = _data["maxAttendees"];
            this.numberOfParticipants = _data["numberOfParticipants"];
            (<any>this).isFull = _data["isFull"];
            this.numberOfWaitingParticipants = _data["numberOfWaitingParticipants"];
            this.maxGuestsPerAttendee = _data["maxGuestsPerAttendee"];
            this.attendance = _data["attendance"] ? AttendanceDto.fromJS(_data["attendance"]) : <any>undefined;
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): EventWithUserAttendance {
        data = typeof data === 'object' ? data : {};
        let result = new EventWithUserAttendance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["name"] = this.name;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["registrationDeadline"] = this.registrationDeadline ? this.registrationDeadline.toISOString() : <any>undefined;
        data["openingTimeForRegistration"] = this.openingTimeForRegistration ? this.openingTimeForRegistration.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["maxAttendees"] = this.maxAttendees;
        data["numberOfParticipants"] = this.numberOfParticipants;
        data["isFull"] = this.isFull;
        data["numberOfWaitingParticipants"] = this.numberOfWaitingParticipants;
        data["maxGuestsPerAttendee"] = this.maxGuestsPerAttendee;
        data["attendance"] = this.attendance ? this.attendance.toJSON() : <any>undefined;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IEventWithUserAttendance {
    eventId?: string;
    name?: string | undefined;
    startDateTime?: Date;
    registrationDeadline?: Date;
    openingTimeForRegistration?: Date;
    location?: string | undefined;
    maxAttendees?: number | undefined;
    numberOfParticipants?: number;
    isFull?: boolean;
    numberOfWaitingParticipants?: number;
    maxGuestsPerAttendee?: number;
    attendance?: IAttendanceDto;
    eventType?: EventType;
}

export class PreviousEvent implements IPreviousEvent {
    eventId?: string;
    eventName?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    location?: string | undefined;
    eventType?: EventType;

    constructor(data?: IPreviousEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventName = _data["eventName"];
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? new Date(_data["endDateTime"].toString()) : <any>undefined;
            this.location = _data["location"];
            this.eventType = _data["eventType"];
        }
    }

    static fromJS(data: any): PreviousEvent {
        data = typeof data === 'object' ? data : {};
        let result = new PreviousEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventName"] = this.eventName;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["location"] = this.location;
        data["eventType"] = this.eventType;
        return data;
    }
}

export interface IPreviousEvent {
    eventId?: string;
    eventName?: string | undefined;
    startDateTime?: Date;
    endDateTime?: Date;
    location?: string | undefined;
    eventType?: EventType;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class SendEmailRequest implements ISendEmailRequest {
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ISendEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ISendEmailRequest {
    subject?: string | undefined;
    body?: string | undefined;
}

export class SendEmailWithEvent implements ISendEmailWithEvent {
    emailRequest?: SendEmailRequest;
    userIds?: string[] | undefined;
    eventId?: string;

    constructor(data?: ISendEmailWithEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.emailRequest = data.emailRequest && !(<any>data.emailRequest).toJSON ? new SendEmailRequest(data.emailRequest) : <SendEmailRequest>this.emailRequest;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailRequest = _data["emailRequest"] ? SendEmailRequest.fromJS(_data["emailRequest"]) : <any>undefined;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.eventId = _data["eventId"];
        }
    }

    static fromJS(data: any): SendEmailWithEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailWithEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailRequest"] = this.emailRequest ? this.emailRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["eventId"] = this.eventId;
        return data;
    }
}

export interface ISendEmailWithEvent {
    emailRequest?: ISendEmailRequest;
    userIds?: string[] | undefined;
    eventId?: string;
}

export class SimpleUser implements ISimpleUser {
    id?: string;
    name?: string | undefined;

    constructor(data?: ISimpleUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SimpleUser {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISimpleUser {
    id?: string;
    name?: string | undefined;
}

export class User implements IUser {
    id?: string;
    name?: string | undefined;
    image?: string | undefined;
    email?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    isAdmin?: boolean;
    preferences?: UserPreferences;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.preferences = data.preferences && !(<any>data.preferences).toJSON ? new UserPreferences(data.preferences) : <UserPreferences>this.preferences;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.image = _data["image"];
            this.email = _data["email"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.isAdmin = _data["isAdmin"];
            this.preferences = _data["preferences"] ? UserPreferences.fromJS(_data["preferences"]) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["image"] = this.image;
        data["email"] = this.email;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["isAdmin"] = this.isAdmin;
        data["preferences"] = this.preferences ? this.preferences.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUser {
    id?: string;
    name?: string | undefined;
    image?: string | undefined;
    email?: string | undefined;
    departmentId?: string | undefined;
    departmentName?: string | undefined;
    isAdmin?: boolean;
    preferences?: IUserPreferences;
}

export class UserPreferences implements IUserPreferences {
    userId?: string;
    darkMode?: boolean;
    language?: string | undefined;
    dietaryConsiderations?: string | undefined;
    eventTypePreferences?: EventType[] | undefined;
    numberOfRowsPerPage?: number | undefined;

    constructor(data?: IUserPreferences) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.darkMode = _data["darkMode"];
            this.language = _data["language"];
            this.dietaryConsiderations = _data["dietaryConsiderations"];
            if (Array.isArray(_data["eventTypePreferences"])) {
                this.eventTypePreferences = [] as any;
                for (let item of _data["eventTypePreferences"])
                    this.eventTypePreferences!.push(item);
            }
            this.numberOfRowsPerPage = _data["numberOfRowsPerPage"];
        }
    }

    static fromJS(data: any): UserPreferences {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferences();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["darkMode"] = this.darkMode;
        data["language"] = this.language;
        data["dietaryConsiderations"] = this.dietaryConsiderations;
        if (Array.isArray(this.eventTypePreferences)) {
            data["eventTypePreferences"] = [];
            for (let item of this.eventTypePreferences)
                data["eventTypePreferences"].push(item);
        }
        data["numberOfRowsPerPage"] = this.numberOfRowsPerPage;
        return data;
    }
}

export interface IUserPreferences {
    userId?: string;
    darkMode?: boolean;
    language?: string | undefined;
    dietaryConsiderations?: string | undefined;
    eventTypePreferences?: EventType[] | undefined;
    numberOfRowsPerPage?: number | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export const overrideStandardDateISOString = () => {
    Date.prototype.toISOString = function () {
        return formatISO(this);
    };
};